const key = {};

export { key };